export const roundTo = (num: number, decimalPlaces: number = 2) => {
  const p = Math.round(parseFloat(num + 'e' + decimalPlaces));
  return Number(p + 'e' + -decimalPlaces);
};
